import React, { useMemo } from "react";


import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import { useDispatch, useSelector } from "react-redux";
import { configApp } from "utils";

import Iframe from "react-iframe";

import { Orientation, useOrientation } from "hooks/orientation";
import { Size, useWindowSize } from "hooks/windowSize";
import { ReporteInfo } from "Interfaces/IParameters";
import { getToken } from "actions/report";
import Layout from "Layout";
import { Head, PowerBiContainer } from "Views/SSRS/styled.component";
import FilterComponent from "Views/SSRS/Components/FilterComponent";


type Props = {
  reporte: ReporteInfo;
};

export const PowerBIReport = ({ reporte }: any) => {
  const [openfilter, setOpenFilter] = React.useState<boolean>(false);
  const [complementoUrl, setComplementoUrl] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<number>(1);
  const [viewMode, setViewMode] = React.useState<string>("Normal");
  const [filterValues, setFilterValues] = React.useState<any>({});

  const { bannerCatalog, titleReport } = useSelector(
    (state: any) => state.theme
  );

  const size: Size = useWindowSize();
  const orientation: Orientation = useOrientation();
  const dispatch = useDispatch();

  /* VIEW MODE */
  React.useEffect(() => {
    if (orientation.orientation === 90) {
      setViewMode("MobileLandscape");
      return;
    }

    if (size.width && size.width < 800) {
      setViewMode("MobilePortrait");
      return;
    }

    setViewMode("Normal");
  }, [orientation, size]);

  /* TOKEN */
  React.useEffect(() => {
    getToken().then((res: any) => {
      if (res?.access_token) {
        dispatch({ type: "token_power", payload: res.access_token });
      }
    });
  }, [dispatch]);

  const existParameters = useMemo(() => {
    return reporte?.parameters && reporte.parameters.length > 0 && reporte.parameters.some((param: any) => param.visible === true);
  }, [reporte]);

  // Inicializar valores por defecto de filtros
  React.useEffect(() => {
    let localParamaters = reporte?.parameters || [];

    if (localParamaters.length > 0) {
      let oParams: any = {};

      for (const parameter of localParamaters) {
        if (parameter.values?.length > 0 && parameter.visible === true) {
          let aFilter = parameter.values.filter(
            (item: any) => item.valorPredeterminado === 1
          );

          if (aFilter.length > 0) {
            let aAplyFilter: Array<any> = [];
            let oFilter: any = {};

            for (const filter of aFilter) {
              if (parameter.tipoParametro === "Combo") {
                aAplyFilter.push({
                  value: filter.value,
                  label: filter.label,
                });
              }

              if (parameter.tipoParametro === "ComboSencillo") {
                oFilter = filter;
              }

              if (parameter.tipoParametro === "Fecha") {
                oFilter = filter.value;
              }
            }
            oParams = {
              ...oParams,
              [parameter.codigoParametro]:
                parameter.tipoParametro === "Combo" ? aAplyFilter : oFilter,
            };
          } else {
            oParams = {
              ...oParams,
              [parameter.codigoParametro]:
                parameter.tipoParametro === "Combo" ? [] : {},
            };
          }
        }
      }

      if (Object.keys(oParams).length > 0) {
        setFilterValues((prevValues: any) => ({ ...prevValues, ...oParams }));
      }
    }
  }, [reporte?.parameters]);

  const urlBi: string = useMemo(() => {
    if (existParameters) {
      setOpenFilter(true);
    }else {
      setIsLoading(3);
    }


    let urlFull = `${configApp.url_powerBi}powerBI.aspx?urlEmbedUrl=https://app.powerbi.com/reportEmbed&reportId=${reporte.idReport}&viewMode=${viewMode}&parametersPowerBi=${complementoUrl}`;
    const replacePatterns = [
      "and powerBiparameters in (RelEmpleadoJefe/idUsuarioPW)",
      "and powerBiparameters in (ConfigPermisosProyecto/idUsuarioPW)",
    ];

    replacePatterns.forEach((pattern) => {
      urlFull = urlFull.replace(pattern, "");
    });

    return urlFull;
  }, [reporte, viewMode, complementoUrl]);

  React.useEffect(() => {
    if (isLoading === 2) {
      const timer = setTimeout(() => setIsLoading(3), 4000);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  return (
    <Layout
      theme={{
        backgroundImage: "none",
        backgroundColor: "#f5f7f7",
      }}
    >
      <Head bg={bannerCatalog}>
        
        {existParameters && [1, 2, 3].includes(isLoading) && (
          <>
            <IconButton
              onClick={() => setOpenFilter(()=> !openfilter)}
              style={{ color: "white" }}
            >
              {openfilter ? <CloseIcon /> : <FilterAltIcon />}
            </IconButton>

            <span
              className={titleReport ? "title-report" : "title-report-city"}
            >
              {reporte.parent} {reporte.name}
            </span>
          </>
        )}
      </Head>


      {urlBi && isLoading === 3 && (
        <PowerBiContainer display={openfilter ? "none" : "flex"}>
          <Iframe
            id="IdFrame"
            url={urlBi}
            position="relative"
            width="98%"
            height="95%"
            className="iframe-pwbi"
            frameBorder={0}
          />
        </PowerBiContainer>
      )}

      {openfilter && (
        <FilterComponent
          filterName={reporte.name}
          parameters={reporte.parameters}
          setValues={setFilterValues}
          type="PowerBI"
          filterValues={filterValues}
          handleViewReport={(parameter: string) => {
            const _filters = parameter
              .trim()
              .substring(0, parameter.trim().length - 3)
              .trim();

            setComplementoUrl(_filters);
            setOpenFilter(false);
            setIsLoading(2);
          }}
        />
      )}
    </Layout>
  );
};
